var exports = {
  "oR": "Toast.module__toast___REVmSG",
  "Gv": "Toast.module__toastMobile___REVmSG",
  "qS": "Toast.module__toastDesktop___REVmSG",
  "Kk": "Toast.module__icon___REVmSG",
  "PO": "Toast.module__iconSuccess___REVmSG",
  "m5": "Toast.module__iconError___REVmSG",
  "oq": "Toast.module__iconMobile___REVmSG",
  "gB": "Toast.module__iconDesktop___REVmSG",
  "Qq": "Toast.module__text___REVmSG",
  "wV": "Toast.module__textMobile___REVmSG",
  "eL": "Toast.module__textDesktop___REVmSG",
};

module.exports = exports;
